export default __webpack_public_path__ + "static/media/waving-hand.6f142e0a.png";